export const Superadmin = "super_admin";
export const MenuType = {
  MONITOR_ALL: "MONITOR_ALL",
  MONITOR_ASSIGNED: "MONITOR_ASSIGNED",
  MONITOR_UNASSIGNED: "MONITOR_UNASSIGNED",
  MONITOR_DELETED: "MONITOR_DELETED",
  FACILITY_ALL: "FACILITY_ALL",
  USER_ALL: "USER_ALL",
  USER_INACTIVE: "USER_INACTIVE",
  USER_ACTIVE: "USER_ACTIVE",
  HELP: "HELP",
  ASSOCIATED_MONITORS: "ASSOCIATED_MONITORS"
};
export const RecordsperPage = 10;
export const Version = "1.5.0";

export const AudioRecordsperPage = 5;

export const DEBOUNCE_TIME = 1000;

export const DeletePopupMsg = {
  emptyMsg: "Please select any record.",
  deleteRecord: "Are you sure you want to delete?",
  FacilityAssociations:
    "Deleting a monitor also deletes previously created facility associations. Are you sure you want to delete?",
  UserFacilityAssociations:
    "Deleting a user also deletes previously created facility associations. Are you sure you want to delete?",
  monitorAssociations:
    "Deleting a facility also deletes previously created monitor associations. Are you sure you want to delete?",
  userAssociations:
    "Deleting a facility also deletes previously created user associations. Are you sure you want to delete?",
  monitorUserAssociations:
    "Deleting a facility also deletes previously created monitor and user associations. Are you sure you want to delete?"
};

export const SortOrder = {
  ASCENDING: "asc",
  DESCENDING: "desc"
};
export const MonitorColumns = {
  STATUS: "status",
  MONITOR_ID: "monitor_id",
  MONITOR_SRNO: "cloud_id",
  LAST_COMMUNICATION: "last_communication"
};
export const UserColumns = {
  USERNAME: "username",
  CREATED_DATE: "created_date",
  PHONE_NUMBER: "phone_number"
};
export const FacilityColumns = {
  NAME: "name",
  ADDRESS: "physical_address",
  FACILITYID: "facility_id",
  CITY: "city",
  STATE: "state",
  ZIP: "zip",
  TIMEZONE: "timezone"
};

export const MenuPath = {
  MONITOR_ALL: "/dashboard/monitors",
  MONITOR_ASSIGNED: "/dashboard/assigned_monitors",
  MONITOR_UNASSIGNED: "/dashboard/unassigned_monitors",
  MONITOR_DELETED: "/dashboard/deleted_monitors",
  FACILITY_ALL: "/dashboard/facilitylist",
  USER_ALL: "/dashboard/users",
  USER_INACTIVE: "/dashboard/inactive_users",
  USER_ACTIVE: "/dashboard/active_users",
  HELP: "/dashboard/usermanual"
};
